/**
 * Synthetic LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SecondLegPairStatusUpdateRequest {
  /**
   * Second leg base pair ID.
   */
  secondLegBasePairId: number;
  /**
   * If True - MD sending forbidden.
   */
  forbiddenSendMd: boolean;
}
